import * as Yup from "yup";

export const DESCRIPTION_MAX_LENGTH = 242;
export const OBSERVATION_MAX_LENGTH = 500;

export const newTimelineItemSchema = Yup.object().shape({
  description: Yup.string()
    .required("O campo descrição é obrigatório.")
    .min(1, "O campo descrição é obrigatório.")
    .max(
      DESCRIPTION_MAX_LENGTH,
      `O campo descrição deve possuir no máximo ${DESCRIPTION_MAX_LENGTH} caracteres.`
    ),
  observation: Yup.string()
    .optional()
    .max(
      OBSERVATION_MAX_LENGTH,
      `O campo observação deve possuir no máximo ${OBSERVATION_MAX_LENGTH} caracteres.`
    ),
});

export type TimelineItemSchema = {
  description: string;
  observation?: string;
};
